export enum EmployeeRoles {
  ALL = "all",
  CREATE_INVENTORY = "create_inventory",
  SEND_COUPONS = "send_coupons",
  UPLOAD_MOCKUPS = "upload_mockups",
  DOWNLOAD_REPORT = "download_report",
  CREATE_ORDER = "create_order",
  EDIT_ORDER = "edit_order",
  CREATE_INVOICE_AND_PI = "create_invoice_and_pi",
  DOWNLOAD_INVOICE_AND_PI = "download_invoice_and_pi",
  ASSIGN_CUSTOMER_TO_ORDER = "assign_customer_to_order",
  CREATE_CUSTOMER = "create_customer",
  EDIT_CUSTOMER = "edit_customer",
  CREATE_USER = "create_user",
  EDIT_USER = "edit_user",
  CREATE_PRODUCT = "create_product",
  EDIT_PRODUCT = "edit_product",
  VIEW_ANALYTICS = "view_analytics",
  VIEW_ORDER = "view_order",
  VIEW_INVENTORY = "view_inventory",
  VIEW_CAMPAIGNS = "view_campaigns",
  VIEW_HRMS = "view_hrms",
  POST_SHIPMENT_DETAILS = "post_shipment_details",
  PROPOSALS = "proposals",
  CREATE_PROJECT = "create_project",
  ADD_PRODUCT_IN_UNIVERSAL_CATALOG = "add_product_in_universal_catalog",
  CHANGE_SELLING_PRICE = "change_selling_price",
  FINANCE_TEAM_PR_ACTIONS = "finance_team_pr_actions",
  SOURCING_TEAM_PR_ACTIONS = "sourcing_team_pr_actions",
  CREATE_PR_AND_PO = "create_pr_and_po",
  CHANGE_COST_PRICE = "change_cost_price",
  PRODUCT_DISPLAY = "product_display",
  PR_PO_VIEW = "pr_po_view",
  SWAGEAZY_INVENTORY_PR_ACTIONS = "swageazy_inventory_pr_actions",
  EDIT_ORDER_AFTER_PROJECT_CREATION = "edit_order_after_project_creation",
  VIEW_URGENT_SOURCING_PRODUCT_PRICE = "view_urgent_sourcing_product_price",
  VIEW_ORDER_PANDL = "view_order_pandl",
  UPDATE_ORDER_CURRENCY_RATE = "update_order_currency_rate",
  VIEW_SHIPMENTS = "view_shipments",
  CREATE_SHIPMENTS = "create_shipments",
  EDIT_SHIPMENTS = "edit_shipments",
  EDIT_PROJECT = "edit_project",
  CREATE_STOCK_CHECK_REQUEST = "create_stock_check_request",
  EDIT_STOCK_CHECK_REQUEST = "edit_stock_check_request",
  CREATE_PROJECT_REQUEST = "create_project_request",
  EDIT_PROJECT_REQUEST = "edit_project_request",
  APPROVE_PROJECT_REQUEST = "approve_project_request",
  CREATE_TASK = "create_task",
  VIEW_VENDORS = "view_vendors",
  EDIT_VENDORS = "edit_vendors",
  VIEW_COUPONS = "view_coupons",
  EDIT_COUPONS = "edit_coupons",
  SEND_REDEMPTION_REMINDERS = "send_redemption_reminders",
  VIEW_CUSTOMER = "view_customer",
  VIEW_USER = "view_user",
  EDIT_ORDER_PARTIAL_PAYMENT = "edit_order_partial_payment",
  CREATE_ADDRESS = "create_address",
  DOWNLOAD_REDEMPTION_REPORT = "download_redemption_report",
  EDIT_ORDER_AMOUNT_RECEIVED = "edit_order_amount_received",
  VIEW_ADDRESS = "view_address",
  VIEW_PARTNER_DASHBOARD = "view_partner_dashboard",
  VIEW_OPS_DASHBOARD = "view_ops_dashboard",
  VIEW_SALES_DASHBOARD = "view_sales_dashboard",
  ADD_PACK_IN_USER_PLACED_SHIPMENTS = "add_pack_in_user_placed_shipments",
  REMOVE_PACK_FROM_USER_PLACED_SHIPMENTS = "remove_pack_from_user_placed_shipments",
  EDIT_ITEMS_FROM_TERMINAL_SHIPMENTS = "edit_items_from_terminal_shipments",
  CANCEL_USER_PLACED_SHIPMENTS = "cancel_user_placed_shipments",
  VIEW_SOURCING_DASHBOARD = "view_sourcing_dashboard",
  EDIT_INVOICE = "edit_invoice",
  VIEW_VENDOR_DASHBOARD = "view_vendor_dashboard",
  VIEW_PROPOSAL_DASHBOARD = "view_proposal_dashboard",
  VIEW_FINANCE_DASHBOARD = "view_finance_dashboard",
  VIEW_QC_DASHBOARD = "view_qc_dashboard",
  VIEW_MOCKUPS_DASHBOARD = "view_mockups_dashboard",
  VIEW_URGENT_SOURCING_DASHBOARD = "view_urgent_sourcing_dashboard",
  VIEW_STOCK_CHECK_DASHBOARD = "view_stock_check_dashboard",
  DELETE_MOCKUP = "delete_mockup",
  EDIT_PRODUCT_SOURCING_DETAILS = "edit_product_sourcing_details",
  EDIT_PRODUCT_SEO_DETAILS = "edit_product_seo_details",
  VIEW_LOGISTICS_DASHBOARD = "view_logistics_dashboard",
  VIEW_NPS_DASHBOARD = "view_nps_dashboard",
  VIEW_CUSTOMER_EXPERIENCE_DASHBOARD = "view_customer_experience_dashboard",
  VIEW_ONELINK_REQUESTS = "view_onelink_requests",
  APPROVE_REJECT_ONELINK_REQUEST = "approve_reject_onelink_request",
  ADMIN_MOCKUP_APPROVE_REJECT = "admin_mockup_approve_reject",
  VIEW_UNPAID_SAMPLES_DASHBOARD = "view_unpaid_samples_dashboard",
  VIEW_ACCOUNT_MANAGEMENT_DASHBOARD = "view_account_management_dashboard",
  SEND_CLIENT_HANDOVER_EMAILER = "send_client_handover_emailer",
  SEND_PROJECTS_CLIENT_EMAILER = "send_projects_client_emailer",
  VIEW_UNPAID_RETURN_SAMPLES = "view_unpaid_return_samples",
  EDIT_UNPAID_RETURN_SAMPLES = "edit_unpaid_return_samples",
  EDIT_UNPAID_RETURN_SAMPLES_PICKUP_INFO = "edit_unpaid_return_samples_pickup_info",
  VIEW_COST_PRICE = "view_cost_price",
  EDIT_ORDER_SEZ = "edit_order_sez",
  VIEW_DASHBOARD_ANALYTICS = "view_dashboard_analytics",
  CREATE_SWAGPACK = "create_swagpack",
  EDIT_SWAGPACK = "edit_swagpack",
  VIEW_VOUCHERS = "view_vouchers",
  CREATE_VOUCHERS = "create_vouchers",
  DOWNLOAD_VOUCHERS = "download_vouchers",
  VIEW_LEADS = "view_leads",
  VIEW_SWAGEAZY_INVENTORY = "view_swageazy_inventory",
  EDIT_SWAGEAZY_INVENTORY = "edit_swageazy_inventory",
  /** Box transfers, stock adjustments (manual + CSV) and SKU transfers. */
  ADJUST_MOVE_SWAGEAZY_INVENTORY = "adjust_move_swageazy_inventory",
  VIEW_URGENT_SOURCING_REQUESTS = "view_urgent_sourcing_requests",
  CREATE_SWAGSTORE = "create_swagstore",
  VIEW_SWAGSTORE = "view_swagstore",
  EDIT_SWAGSTORE = "edit_swagstore",
  ADD_EDIT_PRODUCTS_IN_SWAGSTORE = "add_edit_products_in_swagstore",
  ADD_WALLET_BALANCE = "add_wallet_balance",
  MARK_ORDER_AS_BACKFILL_ALLOWED = "mark_order_as_backfill_allowed",
  MANAGE_SALES_ANALYTICS = "manage_sales_analytics",
  SYNC_ALL_VOUCHER_BRANDS = "sync_all_voucher_brands",
  VIEW_VOUCHER_REQUESTS = "view_voucher_requests",
  INCREASE_ORDER_PRODUCT_OFFER_PRICE = "increase_order_product_offer_price",
  VIEW_VENDOR_REQUESTS = "view_vendor_requests",
  APPROVE_REJECT_VENDOR_REQUESTS = "approve_reject_vendor_requests",
  VIEW_PURCHASE_ORDER_INVOICES = "view_purchase_order_invoices",
  VIEW_VENDOR_PAYMENTS = "view_vendor_payments",
  ADD_EDIT_VENDOR_PAYMENTS = "add_edit_vendor_payments",
  DELETE_VENDOR_PAYMENTS = "delete_vendor_payments",
  UPLOAD_VENDOR_PAYMENTS_CSV = "upload_vendor_payments_csv",
  APPROVE_REJECT_PURCHASE_ORDER_INVOICES = "approve_reject_purchase_order_invoices",
  MARK_PAYMENT_STATUS_PURCHASE_ORDER_INVOICES = "mark_payment_status_purchase_order_invoices",
  UPLOAD_PURCHASE_ORDER_INVOICE = "upload_purchase_order_invoice",
  VIEW_ORDER_PROFIT_MARGIN = "view_order_profit_margin",
  APPROVE_REJECT_VENDOR_REQUESTS_FINANCE = "approve_reject_vendor_requests_finance",
  APPROVE_REJECT_VENDOR_REQUESTS_SOURCING = "approve_reject_vendor_requests_sourcing",
  GENERATE_ORDER_PAYMENT_LINK = "generate_order_payment_link",
  VIEW_EMAILERS = "view_emailers",
  SEND_EMAILERS = "send_emailers",
  EDIT_PRODUCT_SOURCING_PRINTING_DETAILS = "edit_product_sourcing_printing_details",
  VIEW_STORAGE_COST = "view_storage_cost",
  REJECT_APPROVED_MOCKUPS = "reject_approved_mockups",
  RECALCULATE_INVENTORY_STORAGE = "recalculate_inventory_storage",
  ADD_POD_ORDER = "add_pod_order",
  VIEW_POD_CATALOG_VARIANTS = "view_pod_catalog_variants",
  EDIT_POD_CATALOG_VARIANTS = "edit_pod_catalog_variants",
  VIEW_ALLOCATED_POD_ORDER = "view_allocated_pod_order",
  MANAGE_ALLOCATED_POD_PRINT = "manage_allocated_pod_print",
  EDIT_CATEGORY = "edit_category",
  EDIT_PR_AND_PO_AFTER_PO_GENERATION = "edit_pr_and_po_after_po_generation",
  SHORT_CLOSE_PO = "short_close_po",
  APPROVE_STOCK_ISSUE_REQUESTS = "approve_stock_issue_requests",
  VIEW_STOCK_ISSUE_REQUESTS = "view_stock_issue_requests",
  UPLOAD_SWAGPACK_QUANTITY_CSV = "upload_swagpack_quantity_csv",
  FINANCE_TEAM_PROJECT_REQUEST_ACTIONS = "finance_team_project_request_actions",
  VIEW_ORDER_PIPELINE = "view_order_pipeline",
  VIEW_SWAGSTORE_WALLET = "view_swagstore_wallet",
  VIEW_CATALOG = "view_catalog",
  EDIT_CATALOG = "edit_catalog",
  CANCEL_INWARDS = "cancel_inwards",
  DOWNLOAD_PROPOSAL_PDF = "download_proposal_pdf",
  DELETE_ITEM_SKU = "delete_item_sku",
  UPDATE_INVENTORY_ITEMS_COUNT = "update_inventory_items_count",
  VIEW_DISPATCH_DATE = "view_dispatch_date",
  VIEW_PACKAGING_OPS = "view_packaging_ops",
  IMPORT_INVENTORY_ITEMS = "import_inventory_items",
  UPDATE_INVENTORY_SKU = "update_inventory_sku",
  DELETE_INVENTORY_SKU = "delete_inventory_sku",
  VIEW_NEW_OPS_DASHBOARD = "view_new_ops_dashboard",
  VIEW_TASKS_DASHBOARD = "view_tasks_dashboard",
  VIEW_REDEMPTION_DASHBOARD = "view_redemption_dashboard",
  VIEW_ALERTS_DASHBOARD = "view_alerts_dashboard",
  ADD_ORDER_SERVICES = "add_order_services",
  EDIT_ORDER_SERVICES = "edit_order_services",
  ARCHIVE_INCOMPLETE_ORDER = "archive_incomplete_order",
  UNASSIGN_POD_ORDER = "unassign_pod_order",
  UPDATE_POD_ORDER_WAREHOUSE = "update_pod_order_warehouse",
  VIEW_POD_REVENUE_DASHBOARD="view_pod_revenue_dashboard"
}
